function visacurl(urlcrypter, visa){
  // alert('BONJOUR'+ visa + urlcrypter);

  var test = 2;
  var request = new XMLHttpRequest();
  var response;
  request.open('GET', 'https://ghibliapi.herokuapp.com/film', true);
  request.onload = function() {
    // Begin accessing JSON data here
    var data = JSON.parse(this.response);
    response = request.status;
    console.log(request.status);
    console.log(response);

    console.log('data',data);
    test = 4;
    return 200;

  }
  console.log('request.status',i);

  request.send();
  console.log('request.status',request.status);

  return i;


}




